require('./myProfileView.scss');

// @vendors
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';

// @ utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const UrlHelper = require('utilities/urlHelper');
const { getLastNChars } = require('utilities/stringHelper');
// @actions
const myGlobalPositionActions = require('actions/myGlobalPosition');
const aggregatorDataActions = require('actions/aggregator/aggregatorData');
const profileActions = require('actions/profile');
const myProfileShippingAddressActions = require('actions/myProfileShippingAddress');
const tutorialActions = require('actions/tutorial');
const personeticsTeaser = require('actions/personeticsTeaser');
const signaturePattern = require('actions/signaturePattern');
const accessKeyChangeActions = require('actions/accessKeyChange');
const { requestFlagBasedFeatures } = require('actions/flagBasedFeatures');
const { requestFlagBasedMBFeatures } = require('actions/flagBasedMBFeatures');

const {
    sendCollectivesNotification,
    getCollectivesBannerStatus,
} = require('actions/collectiveNotification');
const { okLoanActions } = require('ok-loans');
const { getPersoneticsSubscriptionStatus } = require('actions/personeticsSubscription');
const { getMigrationData } = require('routes/migrationUsersBranchView/actions/migration')

// @components
import InterstitialGeneric from 'components/interstitialGeneric/interstitialGeneric';
import { OKErrorBoundary } from 'components/commons/OKErrorBoundary/OKErrorBoundary';

// @commons
import { LoadingSection } from 'commonsComponents/loadingSection';

// @constants
const {
    PERSONETICS,
    OTP_VITUAL_OFFICE_CHECK,
    PERSONETICS_VIRTUAL_OFFICE_CHECK,
    SENDING_PN_OTP,
    NOT_ALLOWED_NEW_PG_WEALTH_COUNTRIES,
    NOT_ALLOWED_NEW_PREAPPROVAL_LOAN_FLOW_COUNTRIES,
} = require('constants/flagBasedFeatures');

class MyProfileView extends Component {
    componentDidMount() {
        const {
            getCollectivesBannerStatus,
            getShippingAddress,
            immFlagBasedFeatures,
            immProfile,
            immProfileShippingAddress,
            immTutorial,
            location,
            requestAccessKeyData,
            requestFlagBasedFeatures,
            requestFlagBasedMBFeatures,
            requestGetTutorialList,
            requestProfile,
            requestPublicInformation,
            requestTrustedDeviceInfo,
            validateVirtualOfficeForPersonetics,
            validateVirtualOffice,
            sendCollectivesNotification,
            getPersoneticsSubscriptionStatus,
            immPersoneticsSubscriptionDetails,
            history,
            getMigrationData,
        } = this.props;
        const isPersoneticsVirtualOfficeEnabled = immFlagBasedFeatures.get(
            PERSONETICS_VIRTUAL_OFFICE_CHECK
        );
        const isPersoneticsEnabled = immFlagBasedFeatures.get(PERSONETICS);

        if (__CONTACT_CENTER__) {
            setTimeout(() => {
                requestProfile(history); // NOTE: initial call
            }, 2000);
        } else {
            requestProfile(history); // NOTE: initial call
        }

        if (immFlagBasedFeatures.get('web-collectives-notifications')) {
            const queryParams = location.search && UrlHelper.getQueryParams(location.search.substr(1));
            let promoCode, company;
            if (queryParams && queryParams.collective) {
                const decodeCollectiveInfo = atob(queryParams.collective);
                let collectivesQueryParams = UrlHelper.getQueryParams(decodeCollectiveInfo);
                promoCode = collectivesQueryParams.company;
                company = collectivesQueryParams.promo;
            }
            if (promoCode && company) {
                sendCollectivesNotification(promoCode, company);
            } else {
                getCollectivesBannerStatus();
            }
        }

        immProfile.get('originCountry') && requestPublicInformation(immProfile.get('originCountry'), history);
        requestAccessKeyData();
        requestFlagBasedFeatures();
        requestFlagBasedMBFeatures();

        if (
            !immProfileShippingAddress.get('fetchSuccess') &&
            !immProfileShippingAddress.get('isFetching')
        ) {
            getShippingAddress();
        }

        if (!immTutorial.get('fetchSuccess') && immFlagBasedFeatures.get('tutor-database-enabled')) {
            requestGetTutorialList();
        }
        if (!__CONTACT_CENTER__ && immFlagBasedFeatures.get(OTP_VITUAL_OFFICE_CHECK)) {
            validateVirtualOffice();
        }

        if (!__CONTACT_CENTER__ && immFlagBasedFeatures.get(SENDING_PN_OTP)) {
            requestTrustedDeviceInfo();
        }

        if (!__CONTACT_CENTER__ && isPersoneticsVirtualOfficeEnabled && isPersoneticsEnabled) {
            getPersoneticsSubscriptionStatus();
            const isPersoneticsAlreadySubscribed = immPersoneticsSubscriptionDetails.get('isSubscribed');
            const { accounts, cards } = this.getAccountsAndCards();

            isPersoneticsAlreadySubscribed &&
                cards.size > 0 &&
                accounts.size > 0 &&
                validateVirtualOfficeForPersonetics(accounts, cards);
        }

        this.fetchWealthServices({wealthDataRequiered: immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PG_WEALTH_COUNTRIES)});

        if(immProfile.get('originCountry') && immProfile.get('originCountry') == 'DE') {
            getMigrationData();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { location, requestPublicInformation, history } = this.props;
        const currentKey = this.props.routingState.locationBeforeTransitions.key;
        const newKey = nextProps.routingState.locationBeforeTransitions.key;

        if (
            location.pathname !== nextProps.location.pathname &&
            !location.pathname.includes('myprofile/keys/tpps')
        ) {
            requestPublicInformation(undefined, history);
        }

        if (currentKey !== newKey) {
            scrollToTop();
        }
    }

    componentDidUpdate(prevProps) {
        const {
            immProfile,
            requestPublicInformation,
            getSegmentedLoanProducts,
            immFlagBasedFeatures,
            segmentedLoanProducts,
            immPersoneticsSubscriptionDetails,
            validateVirtualOfficeForPersonetics,
            history,
            getMigrationData,
        } = this.props;
        !prevProps.immProfile.get('originCountry') &&
            immProfile.get('originCountry') &&
            requestPublicInformation(immProfile.get('originCountry'), history);
        const isPersoneticsVirtualOfficeEnabled = immFlagBasedFeatures.get(
            PERSONETICS_VIRTUAL_OFFICE_CHECK
        );
        const isPersoneticsEnabled = immFlagBasedFeatures.get(PERSONETICS);
        // We only try to search for segmented products if we have featureflags
        if(__CONTACT_CENTER__){
            if(immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PREAPPROVAL_LOAN_FLOW_COUNTRIES) && 
            immFlagBasedFeatures.get('hasBeenFetched') &&
            !segmentedLoanProducts.get('success') &&
            !segmentedLoanProducts.get('isFetching') ){
                getSegmentedLoanProducts();
            }
        }
        else{
            if(immFlagBasedFeatures.get('hasBeenFetched') &&
            !segmentedLoanProducts.get('success') &&
            !segmentedLoanProducts.get('isFetching') ){
                getSegmentedLoanProducts();
            }
        }
        const isPersoneticsAlreadySubscribed = immPersoneticsSubscriptionDetails.get('isSubscribed');
        const isPersoneticsPrevAlreadySubscribed = prevProps.immPersoneticsSubscriptionDetails.get(
            'isSubscribed'
        );
        if (
            isPersoneticsAlreadySubscribed !== isPersoneticsPrevAlreadySubscribed &&
            !__CONTACT_CENTER__ &&
            isPersoneticsVirtualOfficeEnabled &&
            isPersoneticsEnabled
        ) {
            const { accounts, cards } = this.getAccountsAndCards();
            isPersoneticsAlreadySubscribed &&
                cards.size > 0 &&
                accounts.size > 0 &&
                validateVirtualOfficeForPersonetics(accounts, cards);
        }

        if (
            !prevProps.immProfile.get('originCountry') &&
            immProfile.get('originCountry') &&
            immProfile.get('originCountry') === 'DE'
          ) {
            getMigrationData();
        }
    }
    getAccountsAndCards() {
        const { immAccounts, immCards } = this.props;
        const immCardById = immCards && immCards.get('byId');
        const immCardByOrder = immCards && immCards.get('byOrder');
        const immAccountById = immAccounts && immAccounts.get('byId');
        const immAccountByOrder = immAccounts && immAccounts.get('byOrder');
        const accounts =
            immAccountByOrder &&
            immAccountByOrder.map(accountId => {
                const immAccount = immAccountById && immAccountById.get(accountId);
                return {
                    contractNumber: immAccount.get('newContractNumber'),
                    productType: immAccount.get('newProduct'),
                    productSubtype: immAccount.get('accountType'),
                    standard: immAccount.get('standard'),
                    availableBalance: immAccount.getIn(['balances', 'availableBalance', 'amount']),
                    currentBalance: immAccount.getIn(['balances', 'realBalance', 'amount']),
                };
            });
        const cards =
            immCardByOrder &&
            immCardByOrder.map(cardId => {
                const immCard = immCardById && immCardById.get(cardId);
                return {
                    contractNumber: immCard.getIn(['contract', 'number']),
                    cardId:
                        immCard.getIn(['contract', 'product']) +
                        immCard.getIn(['contract', 'number']) +
                        getLastNChars(immCard.get('number'), 4, ''),
                    productType: immCard.get('newProduct'),
                    productSubtype: immCard.get('productSubType'),
                    standard: immCard.getIn(['product', 'standard']),
                    status: immCard.get('statusCode'),
                    descStatus: immCard.get('status'),
                    availableBalance: immCard.getIn(['availableBalance', 'amount']),
                    disposedBalance: immCard.getIn(['balanceDrawn', 'amount']),
                    limit: immCard.getIn(['limit', 'amount']),
                };
            });
        return { accounts, cards };
    }

    fetchWealthServices = ({ wealthDataRequiered = true }) => {
        const { getWealthDataFF } = this.props;
        if (wealthDataRequiered) {
            getWealthDataFF()
        }
    }

    isCurrentAppRouteForWealth() {
        const { location } = this.props;
        if (location) {
            const currentLocation = location.pathname;
            const brokerPathRegEx = new RegExp('/myprofile/(broker|robo)/');
            return brokerPathRegEx.test(currentLocation);
        }
        return false;
    }

    isCurrentAppRouteForWealthBuscadores() {
        const { location } = this.props;
        if (location) {
            const currentLocation = location.pathname;
            const brokerPathRegEx = new RegExp('/myprofile/broker/explore');
            return brokerPathRegEx.test(currentLocation);
        }
        return false;
    }

    isCurrentAppRouteForAggregator() {
        const { location } = this.props;
        if (location) {
            const currentLocation = location.pathname;
            const brokerPathRegEx = new RegExp('/myprofile/global/entities/');
            return brokerPathRegEx.test(currentLocation);
        }
        return false;
    }

    isCurrentAppRouterForFunds() {
        const { location } = this.props;
        if (location) {
            const currentLocation = location.pathname;
            const brokerPathRegEx = new RegExp('/myprofile/broker/fund/');
            return brokerPathRegEx.test(currentLocation);
        }
        return false;
    }

    isCurrentAppRouterForAlternativeFunds() {
        const { location } = this.props;
        if (location) {
            const currentLocation = location.pathname;
            const brokerPathRegEx = new RegExp('/myprofile/broker/alternative-fund/');
            return brokerPathRegEx.test(currentLocation);
        }
        return false;
    }

    render() {
        const { immFlagBasedFeatures, immGlobalPosition, immProfile, immScreen } = this.props;
        // If globalPosition has not been fetched, we wait until we have it
        // For flagBasedFeatures, We check against 'isFetching' instead of 'hasBeenFetched'
        // because we don't want to block page content to be render if flagBasedFeature service fails
        if (
            !immGlobalPosition.get('hasBeenFetched') ||
            (!__CONTACT_CENTER__ && !immProfile.get('hasBeenFetched')) ||
            immFlagBasedFeatures.get('isFetching')
        ) {
            return (
                <div className="my-profile__spinner">
                    <LoadingSection />
                </div>
            );
        }

        // All the routes are wrapped by this component, so we can put here
        // the responsive grid wrapper (grid-view) if the header is visible.
        const profileSubPageContainerClasses = classNames(
            'my-profile__subpage-container',
            { 'grid-view': immScreen.get('headerIsVisible') },
            {
                'my-profile__subpage-container--no-topbar': immGlobalPosition.get(
                    'isClientWithoutAccounts'
                ),
            }
        );

        const content = <div className={profileSubPageContainerClasses}>{this.props.children}</div>;

        // Checks for specific wealth screens that falls under /myprofile/broker/
        const isWealthView = this.isCurrentAppRouteForWealth();
        const isWealthBuscadoresView = this.isCurrentAppRouteForWealthBuscadores();
        const isAggregatorView = this.isCurrentAppRouteForAggregator();
        const isFundView = this.isCurrentAppRouterForFunds();
        const isAlternativeFundView = this.isCurrentAppRouterForAlternativeFunds();

        const profileSubPageClass = classNames('my-profile__subpage', {
            'my-profile__subpage--wealth': isWealthView,
            'my-profile__subpage--wealth-buscadores': isWealthBuscadoresView,
            'my-profile__subpage--aggregator': isAggregatorView,
            'my-profile__subpage--funds': isFundView,
            'my-profile__subpage--alternativeFunds': isAlternativeFundView,
        });

        const profileClass = classNames('my-profile', {
            'my-profile--aggregator': isAggregatorView,
        });

        return (
            <div className={profileClass}>
                <OKErrorBoundary>
                    <InterstitialGeneric />
                    <div ref={this.setContainerNode} className={profileSubPageClass}>
                        {content}
                        <div className="my-profile__subpage-footer" />
                    </div>
                </OKErrorBoundary>
            </div>
        );
    }
}

MyProfileView.propTypes = {
    children: PropTypes.object,
    getCollectivesBannerStatus: PropTypes.func.isRequired,
    getEntitiesData: PropTypes.func,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immProfileShippingAddress: PropTypes.object,
    immScreen: PropTypes.object.isRequired,
    immTutorial: PropTypes.object.isRequired,
    location: PropTypes.object,
    immCards: PropTypes.object,
    immAccounts: PropTypes.object,
    requestAccessKeyData: PropTypes.func.isRequired,
    requestFlagBasedFeatures: PropTypes.func.isRequired,
    requestFlagBasedMBFeatures: PropTypes.func.isRequired,
    requestGetTutorialList: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    requestPublicInformation: PropTypes.func.isRequired,
    requestTrustedDeviceInfo: PropTypes.func.isRequired,
    routingState: PropTypes.object,
    sendCollectivesNotification: PropTypes.func.isRequired,
    setLegalInterstitial: PropTypes.func,
    getSegmentedLoanProducts: PropTypes.func.isRequired,
    getShippingAddress: PropTypes.func,
    segmentedLoanProducts: PropTypes.shape(),
    validateVirtualOfficeForPersonetics: PropTypes.func,
    validateVirtualOffice: PropTypes.func,
    initPersonetics: PropTypes.func,
    immPersoneticsSubscriptionDetails: PropTypes.object,
    getPersoneticsSubscriptionStatus: PropTypes.func,
    getMigrationData: PropTypes.func,
    history: PropTypes.object.isRequired,
    getWealthDataFF: PropTypes.func,
};

module.exports.constructor = MyProfileView;
module.exports.MyProfileView = withRouter(connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalPosition: state.globalPosition,
        immProfile: state.profile,
        immCards: state.cards,
        immAccounts: state.accounts,
        immProfileShippingAddress: state.myProfileShippingAddress,
        immScreen: state.screen,
        immTutorial: state.tutorial,
        routingState: state.routing,
        segmentedLoanProducts: state.segmentedLoanProducts,
        immPersoneticsSubscriptionDetails: state.personeticsSubscription,
     }),
    {
        getSegmentedLoanProducts: okLoanActions.segmentedLoanProducts.getSegmentedLoanProducts,
        getCollectivesBannerStatus,
        getEntitiesData: aggregatorDataActions.getEntitiesData,
        requestAccessKeyData: accessKeyChangeActions.requestAccessKeyData,
        requestFlagBasedFeatures,
        requestFlagBasedMBFeatures,
        requestTrustedDeviceInfo: signaturePattern.requestTrustedDeviceInfo,
        validateVirtualOfficeForPersonetics: personeticsTeaser.validateVirtualOfficeForPersonetics,
        validateVirtualOffice: signaturePattern.validateVirtualOffice,
        requestGetTutorialList: tutorialActions.requestGetTutorialList,
        initPersonetics: personeticsTeaser.initPersonetics,
        requestProfile: profileActions.requestProfile,
        getShippingAddress: myProfileShippingAddressActions.getShippingAddress,
        requestPublicInformation: myGlobalPositionActions.requestPublicInformation,
        sendCollectivesNotification,
        getPersoneticsSubscriptionStatus,
        getWealthDataFF: myGlobalPositionActions.getWealthDataFF,
        getMigrationData,
    }
)(MyProfileView));
